import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Header } from "../../header";
import { Footer } from "../../components/footer";

import CDEKLogo from './img/CDEKLogo.png';

export const PaymentPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const [deliveryType, setDeliveryType] = useState("");
  const [trackCode, setTrackCode] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const [date, setDate] = useState(0);
  const [amount, setAmount] = useState(0);

  const paymentUrl = searchParams.get("paymentUrl");

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const response = await axios.get('https://api.alyonatestsite.store/api/order', {
          params: { id: id },
        });

        setPaymentStatus(response.data.status);
        setAmount(response.data.amount);
        setDeliveryType(response.data.deliveryType);
        setTrackCode(response.data.cdekTrackCode);
      } catch (error) {
        console.error("Ошибка", error.response?.data || error.message);
        setPaymentStatus("error");
      } finally {
        setIsLoading(false);
      }
    };

    checkPaymentStatus();
  }, [id]);

  useEffect(() => {
    const getOrder = async () => {
      try {
        const response = await axios.get(`https://api.alyonatestsite.store/api/order`, {
          params: { id: id },
        });

        setCart(response.data.cart);
        setDate(response.data.date);
      } catch (error) {
        console.error("Error getting the order", error.response?.data || error.message);
      }
    };

    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://api.alyonatestsite.store/api/products");
        const allProducts = response.data;

        const enrichedProducts = cart.map((cartItem) => {
          const product = allProducts.find((p) => p.id === cartItem.id);
          return product ? { ...cartItem, ...product } : cartItem;
        });

        setProducts(enrichedProducts);
      } catch (err) {
        console.error("Ошибка загрузки товаров:", err);
      }
    };

    getOrder();
    fetchProducts();
  }, [cart, id]);

  const fullDate = new Date(date);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = fullDate.toLocaleDateString('ru-RU', options);

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header fixed={false} page="merch" />
        <div className="flex-grow flex items-center justify-center p-12">
          <p className="text-xl">Проверка статуса оплаты...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (paymentStatus === "error") {
    return (
      <div className="flex flex-col min-h-screen bg-white">
      <Header fixed={false} />
      <div className="flex-grow flex flex-col items-center justify-center p-12">
        <h1 className="font-lack text-4xl text-center">Заказ не найден</h1>
        <p className="mt-4 text-xl text-center">
          Возможно, заказ был удалён или вы указали неверный идентификатор.
        </p>
        <p className="mt-2 text-lg text-center">
          Пожалуйста, проверьте данные или обратитесь в поддержку.
        </p>
        <a
          href="https://t.me/alyonashvetsmerch_bot"
          target="_blank"
          rel="noreferrer"
          className="mt-6 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition duration-300"
        >
          Связаться с поддержкой
        </a>
      </div>
      <Footer />
    </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen w-full items-center bg-gray-50">
      <Header fixed={false} />
      <div className="flex-grow flex flex-col w-full max-w-4xl px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-8">
          <div className="flex flex-col">
            <h1 className="font-lack text-4xl">{`Заказ #${id}`}</h1>
            <p className="font-lack text-lg mt-2">{`Создан ${formattedDate}`}</p>
          </div>
          <div className="flex flex-col justify-center items-center mt-4 md:mt-0">
            <h1 className="font-lack text-4xl">{`${amount}руб.`}</h1>
          </div>
        </div>

        <a
          className="py-2 px-4 bg-blue-500 font-lack text-lg text-white text-center rounded-xl hover:bg-blue-600 transition duration-300"
          href={`https://t.me/alyonashvetsmerch_bot/?start=${id}`}
          rel="noreferrer"
          target="_blank"
        >
          Следить за статусом заказа в Telegram
        </a>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {products.map((item) => (
            <a
              key={item.id}
              href={`/merch/product/?id=${item.id}`}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 h-full"
            >
              <img
                src={`https://api.alyonatestsite.store${item.images[0]}`}
                alt={item.name}
                className="w-28 h-28 object-cover rounded-xl"
              />
              <p className="mt-2 text-center font-lack text-lg">{item.name} {item.quantity} шт.</p>
              <p className="mt-1 text-center font-lack text-gray-400 text-sm">{item.size ? item.size : ''}</p>
              <div className="flex-grow"></div>
              <p className="mt-2 text-center font-lack text-lg">{item.price * item.quantity} руб.</p>
            </a>
          ))}
        </div>

        <div className="w-full mt-8 border-t border-gray-300"></div>

        <div className="flex flex-col md:flex-row justify-between w-full py-8 space-y-8 md:space-y-0 md:space-x-8">
          <div className="flex flex-col items-center space-y-4">
            <div className={`relative h-28 w-28 rounded-full flex items-center justify-center ${paymentStatus === 'success' || paymentStatus === 'finished' || paymentStatus === 'packed' ? 'bg-green-500' : 'bg-sky-200'} transition-colors duration-300`}>
              {(paymentStatus === 'success' || paymentStatus === 'finished' || paymentStatus === 'packed') && (
                <span className="text-white text-4xl">✔</span>
              )}
            </div>
            <p className="font-lack text-lg text-center">
              {`${paymentStatus === 'success' || paymentStatus === 'packed' || paymentStatus === 'finished' ? 'Заказ оплачен' : 'Ожидает оплаты'}`}
            </p>
            <a
              href={paymentUrl}
              className={`${paymentStatus !== 'pending' && 'hidden'} bg-sky-500 text-white px-4 py-2 rounded-lg hover:bg-sky-600 transition duration-300`}
            >
              Перейти к оплате
            </a>
          </div>
          <div className="flex flex-col items-center space-y-4">
            <div className={`relative h-28 w-28 rounded-full flex items-center justify-center ${paymentStatus === 'success' ? 'bg-sky-200' : paymentStatus === 'packed' || paymentStatus === 'finished' ? 'bg-green-500' : 'bg-gray-400'} transition-colors duration-300`}>
              {(paymentStatus === 'packed' || paymentStatus === 'finished') && (
                <span className="text-white text-4xl">✔</span>
              )}
            </div>
            <p className="font-lack text-lg text-center">
              {`${paymentStatus === 'success' ? 'Идёт сборка' : paymentStatus === 'packed' || paymentStatus === 'finished' ? 'Заказ собран' : 'Сборка'}`}
            </p>
          </div>
          <div className="flex flex-col items-center space-y-4">
            <div className={`relative h-28 w-28 rounded-full flex items-center justify-center ${paymentStatus === 'packed' ? 'bg-sky-200' : paymentStatus === 'finished' ? 'bg-green-500' : 'bg-gray-400'} transition-colors duration-300`}>
              {paymentStatus === 'finished' && (
                <span className="text-white text-4xl">✔</span>
              )}
            </div>
            <p className="font-lack text-lg text-center whitespace-pre-line">
              {`${paymentStatus === 'packed' ? `В доставке (${deliveryType == '136' ? 'до ПВЗ' : 'курьером'})\n` : paymentStatus === 'finished' ? 'Заказ доставлен' : 'Доставка'}`}
            </p>
            <button
              className={`${paymentStatus === 'packed' || paymentStatus === 'finished' ? '' : 'hidden'} font-lack rounded-xl text-black border border-green-500 bg-white w-full px-2 py-1 hover:bg-green-50 transition duration-300`}
              onClick={() => window.location.href = `https://www.cdek.ru/ru/tracking/?order_id=${trackCode}`}
            >
              Отследить заказ
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};